import requestFunctions from "../../functions/requestFunctions";
import strFunctions from "../../functions/strFunctions";

export const state = {
  FINANCE_ITEM: {},
  FINANCE_LIST: [],
  FINANCE_TABLE_DATA: [],
  FINANCE_TOTAL_ROWS: 0
}

export const getters = {
  GET_FINANCE_ITEM: (state) => {
    return state.FINANCE_ITEM;
  },
  GET_FINANCE_LIST: (state) => {
    return state.FINANCE_LIST;
  },
  GET_FINANCE_TABLE_DATA: (state) => {
    return state.FINANCE_TABLE_DATA;
  },
  GET_FINANCE_TOTAL_ROWS: (state) => {
    return state.FINANCE_TOTAL_ROWS;
  }
}

export const mutations = {

  UPDATE_FINANCE_ITEM(state, item) {
    state.FINANCE_ITEM = item;
  },

  UPDATE_FINANCE_LIST(state, list) {

    state.FINANCE_LIST = list.data;
    state.FINANCE_TABLE_DATA = [];

    state.FINANCE_TOTAL_ROWS = list.total;
    list = list.data;

    if (list.length > 0) {
      list.forEach(el => {

        let status;

        if(el.status === 'wait'){
          status = 'Ожидается оплата'
        }
        if(el.status === 'blocked'){
          status = 'Заблокирована'
        }
        if(el.status === 'cancelled'){
          status = 'Отменена'
        }
        if(el.status === 'success'){
          status = 'Успешно'
        }
        if(el.status === 'error'){
          status = 'Ошибка'
        }
        if(el.status === 'payment'){
          status = 'Оплачивается'
        }

        let bank_account_from = '';
        bank_account_from = strFunctions.strConcat(', ', bank_account_from, el.bank_account_from_name ? el.bank_account_from_name : '');
        bank_account_from = strFunctions.strConcat(', ', bank_account_from, el.bank_account_from_rs ? el.bank_account_from_rs : '');
        bank_account_from = strFunctions.strConcat(', ', bank_account_from, el.bank_account_from_bank_name ? el.bank_account_from_bank_name : '');
        // fallback for legacy response
        bank_account_from = strFunctions.strConcat(', ', bank_account_from, el.account_from_number ? el.account_from_number : '');

        let bank_account_to = '';
        bank_account_to = strFunctions.strConcat(', ', bank_account_to, el.bank_account_to_name ? el.bank_account_to_name : '');
        bank_account_to = strFunctions.strConcat(', ', bank_account_to, el.bank_account_to_rs ? el.bank_account_to_rs : '');
        bank_account_to = strFunctions.strConcat(', ', bank_account_to, el.bank_account_to_bank_name ? el.bank_account_to_bank_name : '');
        // fallback for legacy response
        bank_account_to = strFunctions.strConcat(', ', bank_account_to, el.account_to_number ? el.account_to_number : '');

        let type_name = '';
        if (el.type === 'income') {
          type_name = 'Доход'
        }
        if (el.type === 'expense') {
          type_name = 'Расход'
        }
        if (el.type === 'transfer') {
          type_name = 'Перемещение'
        }

        state.FINANCE_TABLE_DATA.push({
          'id': el.id,
          'uuid': el.uuid,
          'created_at': el.created_at,
          'type': el.type,
          'type_name': type_name,
          'finance_type_name': el.finance_type_name,
          'finance_type_code': el.finance_type_code,
          'bank_account_from': bank_account_from,
          'bank_account_to': bank_account_to,
          'counterparty_name': el.counterparty_name,
          'company_name': el.company_name,
          'currency_from_code': el.currency_from_code,
          'currency_to_code': el.currency_to_code,
          'pay_method_name': el.pay_method_name,
          'pay_gate_name': el.pay_gate_name,
          'recipient_details': el.recipient_details,
          'tariff_name': el.tariff_name,
          'comments': el.comments,
          'sum': el.sum,
          'status': status,
          'updated_at': el.updated_at,
        });

      });
    }
  }
}


export const actions = {

  async FETCH_FINANCE_ITEM({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/finance/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_FINANCE_ITEM', response.data);
      return response.data;
    }

  },

  async FETCH_FINANCE_LIST({ commit }, payload= {}) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/finance';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_FINANCE_LIST', response.data);
      return response.data;
    }
  },

  async FETCH_FINANCE_CREATE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/finance';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_FINANCE_UPDATE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/finance/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_FINANCE_DELETE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/finance/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },
}